import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';


const DialogeBox = props => {
    const { open, title, message, button1text, button2text, button1clickhandler, button2clickhandler } = props;

    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {button1text == undefined ? null : (<Button onClick={button1clickhandler} color="primary">
                    {button1text}
                </Button>)}
                {button2text == undefined ? null : (<Button onClick={button2clickhandler} color="primary">
                    {button2text}
                </Button>)}
            </DialogActions>
        </Dialog>
    );
};

DialogeBox.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    //message: PropTypes.string.isRequired,
    button1text: PropTypes.string.isRequired,
    button1clickhandler: PropTypes.func.isRequired
};

export default DialogeBox;
